import { useState } from 'react';

import { Box, Typography } from '@mui/material';

import { IPromotion, WebsiteService } from 'api/website';

import AspectRatio from 'components/common/AspectRatio';
import Slider from 'components/common/Slider';
import SliderAppendDots from 'components/common/Slider/SliderAppendDots';
import PromotionCard from 'components/sections/PromotionCard';

import useScreen from 'hooks/useScreen';
import useTranslates from 'utils/translate';
import useMount from 'hooks/useMount';

const PromotionsSection = () => {
  const { isMobile, isTablet, is13Inch } = useScreen();
  const { translate } = useTranslates();

  const [promotions, setPromotions] = useState<IPromotion[]>([]);

  useMount(() => {
    WebsiteService.getPromotions({ langId: 1 }).then(setPromotions);
  });

  if (!promotions?.length) {
    return null;
  }

  const count = isMobile ? 2 : isTablet ? 4 : 5;
  const slidesToShow = promotions?.length >= count ? count : promotions?.length;

  const maxWidth = isTablet ? 40 : is13Inch ? 20 : 15;

  return (
    <Box component="section" my={3} mx={isMobile && -3}>
      <Typography fontSize={isMobile ? 12 : 18} textAlign="center" fontWeight="700" data-testid="promotions">
        {translate('promotions')}
      </Typography>

      <Box pt={2} px={2} maxWidth={isMobile ? '100%' : `${slidesToShow * maxWidth}%`} m="0 auto">
        <Slider
          dots
          arrows={false}
          infinite={false}
          slidesToShow={slidesToShow}
          appendDots={(dots) => <SliderAppendDots dots={dots} />}
        >
          {promotions?.map((promotion, index) => (
            <AspectRatio key={index} divide="3:4" spacing={1}>
              <PromotionCard my={0} m={0} promotion={promotion} width="100%" height="100%" />
            </AspectRatio>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

export default PromotionsSection;
